import React, { useEffect } from 'react';
import { useRouter } from '@tanstack/react-router';
import parse from 'html-react-parser';

import { useStore } from '../store';

const Notices: React.FC = () => {
  const store = useStore();
  const { notice } = store;

  useEffect(() => {
    if (notice) {
      if (notice?.displayed) {
        useStore.setState({ notice: null });
      } else {
        useStore.setState({ notice: { ...notice, displayed: true } });
      }
    }
  }, [useRouter().state.matches]);

  if (!notice) return null;

  interface Notice {
    type: 'success' | 'brand' | 'neutral' | 'warning' | 'danger' | undefined;
    message: string;
    dismiss?: boolean;
    displayed?: boolean;
  };

  const noticeTypeIcons: Record<string, string> = {
    success: 'fa-circle-check',
    brand: 'fa-circle-check',
    neutral: 'fa-circle-check',
    warning: 'fa-triangle-exclamation',
    danger: 'fa-circle-exclamation',
  };

  const buttonAppearances: Record<string, 'outlined' | 'accent' | 'filled' | 'filled-outlined' | 'plain' | undefined> = {
    success: 'outlined',
    brand: 'outlined',
    neutral: 'outlined',
    warning: 'accent',
    danger: 'accent',
  };

  const notices: Record<string, Notice> = {
    'memory.created': {
      type: 'success',
      message: 'Your memory is <span>created</span> — now share it with the people who matter.',
    },
    'memory.updated': {
      type: 'success',
      message: 'Your memory is <span>updated</span> — now share it with the people who matter.',
    },
    'sprk.created': {
      type: 'success',
      message: 'You&apos;ve <span>sent a SPRK</span>! Copy the link or share it with up to 5 people.',
    },
    'sprk.updated': {
      type: 'success',
      message: 'Your SPRK is <span>updated</span>.',
    },
    'timeline.created': {
      type: 'success',
      message: 'Your timeline is <span>created</span> — now share it with the people who matter.',
    },
    'timeline.updated': {
      type: 'success',
      message: 'Your timeline is <span>updated</span> — now share it with the people who matter.',
    },
    'profile.updated': {
      type: 'success',
      message: 'Your profile has been <span>updated</span>.',
      dismiss: true,
    },
    'password.updated': {
      type: 'success',
      message: 'Your password has been <span>updated</span>.',
      dismiss: true,
    },
    'update.failed': {
      type: 'danger',
      message: 'Something went wrong — please try again or contact us.',
    },
  };

  if (!notices[notice.type || '']) return null;

  const icon = noticeTypeIcons[notices[notice.type || ''].type || ''] || 'fa-circle-info';
  const buttonAppearance = buttonAppearances[notices[notice.type || ''].type || ''] || 'outlined';
  if (notices[notice.type || ''].dismiss) {
    setTimeout(() => {
      useStore.setState({ notice: null });
    }, 5000);
  };
  const message = notice.message ||notices[notice.type || ''].message;

  return (
    <div className="notices">
      <wa-callout variant={notices[notice.type || ''].type}>
        <div className="wa-split wa-gap-xs">
          <div className="notices-message">
            <i className={`fa-regular ${icon}`} slot="icon" />
            <strong>{parse(message)}</strong>
          </div>
          <div className="wa-align-self-end notices-dismiss">
            <wa-button pill size="s" appearance={buttonAppearance} onClick={() => useStore.setState({ notice: null })}>
              Dismiss
            </wa-button>
          </div>
        </div>
      </wa-callout>
    </div>
  );
}

export default Notices;
